import React, { Component } from "react";

import {
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Loading from "../../../../components/Loading";
import EstatisticasTurma from "../../../../components/Statistics/EstatisticasTurma";
import EstatisticasTurmaAluno from "../../../../components/Statistics/EstatisticasTurmaAluno";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "./styles.css";

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // list: [],
      loading: true,
      // applications: [],
      menu: "Estatísticas da turma por atividade",
      // dropdownItems: false,
      room: { activities: [], users: [] }
    };
  }

  async componentDidMount() {
    const respRoom = await axios.get(
      `${URL.api}community/room/report?room_id=${this.props.room_id}`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState({
      room: respRoom.data.data,
      loading: false
    });
  }

  getMenus() {
    return [
      {
        name: "Estatísticas da turma por atividade",
        component: (
          <EstatisticasTurma
            room={this.state.room?.activities.filter(
              item => item.activity != null
            )}
          />
        )
      },
      {
        name: "Estatísticas da turma por estudante",
        component: <EstatisticasTurmaAluno room={this.state.room} />
      }
    ];
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>Estatísticas da turma - {this.props.name}</CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.getMenus()
              .filter(menu => !menu.hideMenu)
              .map(menu => (
                <CListGroupItem
                  action
                  active={menu.name === this.state.menu}
                  style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
                  className="cursor"
                  onClick={() => this.setState({ menu: menu.name })}
                >
                  {menu.name}
                </CListGroupItem>
              ))}
          </CListGroup>
          {this.state.loading ? (
            <div
              className="p-3 charts flex-1 d-flex flex-column align-items-center justify-content-center"
              style={{ overflow: "auto" }}
            >
              <Loading />
            </div>
          ) : (
            <div
              className="p-3 charts flex-1 d-flex flex-column align-items-center"
              style={{ overflow: "auto" }}
            >
              <span className="est-text mb-3">
                <h1>{this.state.menu}</h1>
              </span>
              {
                this.getMenus().find(menu => menu.name === this.state.menu)
                  .component
              }
            </div>
          )}
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);
